/* Punartha "Buy now": adds the selected variant to the cart, then goes
   straight to checkout. Mirrors the Add to cart button's disabled state so
   variant changes (sold out / unavailable) stay in sync. */
if (!customElements.get('buy-now-button')) {
  customElements.define(
    'buy-now-button',
    class BuyNowButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.productForm = this.closest('product-form');
        this.form = this.productForm?.querySelector('form');
        this.cartButton = this.productForm?.querySelector('[name="add"]');
        if (!this.button || !this.form) return;

        this.button.addEventListener('click', this.onClick.bind(this));

        if (this.cartButton) {
          this.syncDisabled();
          this.observer = new MutationObserver(() => this.syncDisabled());
          this.observer.observe(this.cartButton, { attributes: true, attributeFilter: ['disabled'] });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      syncDisabled() {
        this.button.disabled = this.cartButton.hasAttribute('disabled');
      }

      setLoading(isLoading) {
        this.button.classList.toggle('loading', isLoading);
        this.button.setAttribute('aria-disabled', isLoading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      }

      async onClick() {
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        this.productForm.handleErrorMessage?.();
        this.setLoading(true);

        const formData = new FormData(this.form);
        const variantId = Number(formData.get('id'));
        const checkoutUrl = this.button.dataset.checkoutUrl || '/checkout';

        try {
          const response = await fetch(`${routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });

          if (response.ok) {
            window.location.href = checkoutUrl;
            return;
          }

          // A single-stock piece that is already in the cart cannot be added
          // again; the shopper still wants to buy it, so go to checkout.
          const error = await response.json().catch(() => ({}));
          const cart = await fetch(`${routes.cart_url}.js`).then((res) => res.json());
          if (cart.items?.some((item) => item.variant_id === variantId)) {
            window.location.href = checkoutUrl;
            return;
          }

          this.productForm.handleErrorMessage?.(error.description || error.message);
        } catch (e) {
          console.error(e);
        }

        this.setLoading(false);
      }
    }
  );
}
